// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vv6L","newExpiryDate":"styles_newExpiryDate__1O2k7","footer":"styles_footer__3mtTb"};